<div *ngIf="selectedInsiders.length > 0; else noData">
  <p-table
    [value]="selectedInsiders"
    [rows]="5"
    [tableStyle]="{ 'min-width': '50rem' }"
    selectionMode="single"
    dataKey="arcId"
  >
    <ng-template pTemplate="caption">
      <div class="flex justify-end items-center space-x-2 w-full">
         <div>
      <!-- <label class="block text-sm font-medium mb-1">Plan Action</label> -->
      <p-dropdown
        [options]="insiderList"
        [(ngModel)]="selectedMappedInsider"
        optionLabel="label"
        optionValue="value"
        placeholder="Select Insider"
        class="w-full"
        size="large"
        (onChange)="onInsiderSelect($event)"
      ></p-dropdown>
    </div>
        <div class="relative w-60">
          <input
            type="text"
            [(ngModel)]="searchInsider"
            (keydown.enter)="onChildSearchEnter()"
            placeholder="Type and press Enter to search..."
            class="border border-gray-300 rounded px-3 py-1.5 text-sm w-full"
            (focus)="showChildDropdown = filteredInsiders.length > 0"
            (keydown)="preventSpaceKey($event)"
            (paste)="onPaste($event, 'searchInsider')"
          />
          <div
            *ngIf="showChildDropdown && filteredInsiders.length > 0"
            class="absolute z-50 mt-1 w-full border border-gray-300 bg-white shadow-md max-h-60 overflow-auto rounded"
          >
            <div
              *ngFor="let insider of filteredInsiders"
              class="px-3 py-2 hover:bg-gray-100 cursor-pointer text-sm"
              (click)="onInsiderSelect(insider)"
            >
              {{ insider.asReportedInsiderName || "N/A" }}
            </div>
          </div>
        </div>
      </div>
    </ng-template>
    <ng-template #header>
      <tr>
        <th>A R A. Id</th>
        <th>Insider Name</th>
        <th>Reporting Entity Name</th>
        <th>Reporting Entity Type</th>
        <th>Insider Role In Entity</th>
        <th>CIK</th>
        <th>Issuer Name</th>
        <th>Insider Comment</th>
      </tr>
    </ng-template>
    <ng-template #body let-insider>
      <tr>
        <td>{{ insider.asReportedInsiderId || "N/A" }}</td>
        <td>{{ insider.asReportedInsiderName || "N/A" }}</td>
        <td>{{ insider.asReportedReportingEntityName || "N/A" }}</td>
        <td>{{ insider.asReportedReportingEntityType || "N/A" }}</td>
        <td>{{ insider.asReportedInsiderRoleInEntity || "N/A" }}</td>
        <td>{{ insider.insiderCik || "NA" }}</td>
        <td>{{ insider.asReportedIssuerName || "NA" }}</td>
        <td>
          <span
            *ngIf="insider.insiderComment"
            [pTooltip]="insider.insiderComment"
            tooltipPosition="top"
            [tooltipStyleClass]="'custom-tooltip'"
            [autoHide]="false"
            class="block max-w-[200px] overflow-hidden text-ellipsis whitespace-nowrap"
          >
            {{ insider.insiderComment }}
          </span>
          <span *ngIf="!insider.insiderComment">—</span>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
<ng-template #noData>
  <div class="text-center py-6 text-gray-500">No record found.</div>
</ng-template>
<div class="mt-8">
  <p-table
    [value]="secondTableInsiders"
    [rows]="5"
    [tableStyle]="{ 'min-width': '50rem' }"
    selectionMode="single"
    [(selection)]="selectedDialogRow"
    dataKey="asReportedInsiderId"
    (onRowSelect)="onDialogRowSelect($event)"
    (onRowUnselect)="onDialogRowUnselect($event)"
  >
    <ng-template pTemplate="header">
      <tr>
        <th>Insider Name</th>
        <th>CIK</th>
        <th>Issuer Name</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-insider>
      <tr [pSelectableRow]="insider">
        <td>{{ insider.asReportedInsiderName || "N/A" }}</td>
        <td>{{ insider.insiderCik || "NA" }}</td>
        <td>{{ insider.companyName || "N/A" }}</td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td
          colspan="3"
          class="py-6 text-gray-500"
          style="text-align: center !important"
        >
          No record found.
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<div
  class="grid gap-6 my-6 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 border border-gray-200 rounded-lg p-6 bg-white"
>
  <div class="relative z-0 w-full mb-5 group">
    <input
      type="text"
      name="companyName"
      [(ngModel)]="childFormData.affiliateName"
      [ngClass]="{
        'border-red-500': validationErrors.affiliateName
      }"
      class="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-[#1f273b] peer"
      placeholder=" "
      (keydown)="preventSpaceKey($event)"
      (paste)="onPaste($event, 'affiliateName')"
      (input)="validationErrors.affiliateName = ''"
    />
    <label
      class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto peer-focus:text-[#1f273b] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
    >
      Insider name
    </label>
    <small
      *ngIf="validationErrors.affiliateName"
      class="text-red-500 text-xs mt-1 block"
    >
      {{ validationErrors.affiliateName }}
    </small>
  </div>
  <div class="relative z-0 w-full mb-5 group">
    <input
      type="text"
      name="cik"
      [(ngModel)]="childFormData.cik"
      class="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-[#1f273b] peer"
      placeholder=" "
      (keydown)="preventSpaceKey($event)"
      (paste)="onPaste($event, 'cik')"
    />
    <label
      class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto peer-focus:text-[#1f273b] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
    >
      Cik
    </label>
  </div>
  <div class="relative z-0 w-full mb-5 group">
    <input
      type="text"
      name="cik"
      readonly
      [(ngModel)]="childFormData.p2iq"
      class="block py-2.5 px-0 w-full read-only text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-[#1f273b] peer"
      placeholder=" "
      (keydown)="preventSpaceKey($event)"
      (paste)="onPaste($event, 'p2iq')"
    />
    <label
      class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto peer-focus:text-[#1f273b] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
    >
      p2iq
    </label>
  </div>
  <div class="relative z-0 w-full mb-5 group">
    <input
      type="text"
      name="insiderComment"
      [(ngModel)]="childFormData.insiderComment"
      class="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-[#1f273b] peer"
      placeholder=" "
      (keydown)="preventSpaceKey($event)"
      (paste)="onPaste($event, 'insiderComment')"
    />
    <label
      class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto peer-focus:text-[#1f273b] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
    >
      Insider Comment
    </label>
  </div>
</div>

<div *ngIf="!isIndividual" class="mt-4 flex items-center space-x-2 ">
    <input
      type="checkbox"
      [(ngModel)]="showParentForm"
      class="h-4 w-4 text-[#1f273b] cursor-pointer border-gray-300 rounded"
    />
    <span class="text-gray-700 text-sm">Add Insider</span>
</div>

<div *ngIf="!isIndividual && showParentForm">
  <div class="flex justify-end space-x-2 items-center w-full">
    <div>
        <p-dropdown
        [options]="insiderList"
        [(ngModel)]="selectedParentMappedInsider"
        optionLabel="label"
        optionValue="value"
        placeholder="Select Insider"
        class="w-full"
        size="large"
        (onChange)="onParentInsiderSelect($event)"
      ></p-dropdown>
    </div>
   
    <div class="relative w-60">
      <input
        type="text"
        [(ngModel)]="parentSearchInsider"
        (keydown.enter)="onParentSearchEnter()"
        placeholder="Type and press Enter to search..."
        class="border border-gray-300 rounded px-3 py-1 text-sm w-full"
        (focus)="showParentDropdown = parentFilteredInsiders.length > 0"
        (keydown)="preventSpaceKey($event)"
        (paste)="onPaste($event, 'parentSearchInsider')"
      />
      <div
        *ngIf="showParentDropdown && parentFilteredInsiders.length > 0"
        class="absolute z-50 mt-1 w-full border border-gray-300 bg-white shadow-md max-h-60 overflow-auto rounded"
      >
        <div
          *ngFor="let insider of parentFilteredInsiders"
          class="px-3 py-2 hover:bg-gray-100 cursor-pointer text-sm"
          (click)="onParentInsiderSelect(insider)"
        >
          {{ insider.asReportedInsiderName || "N/A" }}
        </div>
      </div>
    </div>
  </div>
  <div
    class="grid gap-6 my-6 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 border border-gray-200 rounded-lg p-6 bg-white"
  >
    <div class="relative z-0 w-full mb-5 group">
      <input
        type="text"
        name="companyName"
        [(ngModel)]="parentFormData.parentInsiderName"
        class="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-[#1f273b] peer"
        placeholder=" "
        (keydown)="preventSpaceKey($event)"
        (paste)="onPaste($event, 'parentInsiderName')"
      />
      <label
        class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto peer-focus:text-[#1f273b] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
      >
        Insider name
      </label>
    </div>

    <div class="relative z-0 w-full mb-5 group">
      <input
        type="text"
        name="cik"
        [(ngModel)]="parentFormData.parentCik"
        class="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-[#1f273b] peer"
        placeholder=" "
        (keydown)="preventSpaceKey($event)"
        (paste)="onPaste($event, 'parentCik')"
      />
      <label
        class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto peer-focus:text-[#1f273b] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
      >
        Cik
      </label>
    </div>
    <div class="relative z-0 w-full mb-5 group">
      <p-dropdown
        [options]="relationshipOptions"
        [(ngModel)]="parentFormData.insiderrelationshipreason"
        optionLabel="label"
        optionValue="value"
        placeholder="Select relationship"
        [appendTo]="'body'"
        class="w-full"
      ></p-dropdown>
    </div>
    <div class="relative z-0 w-full mb-5 group">
      <input
        type="text"
        name="cik"
        readonly
        [(ngModel)]="parentFormData.p2iq"
        class="block py-2.5 px-0 w-full read-only text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-[#1f273b] peer"
        placeholder=" "
        (keydown)="preventSpaceKey($event)"
        (paste)="onPaste($event, 'p2iq')"
      />
      <label
        class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto peer-focus:text-[#1f273b] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
      >
        p2iq
      </label>
    </div>
     <div class="relative z-0 w-full mb-5 group">
    <input
      type="text"
      name="insiderComment"
      [(ngModel)]="parentFormData.insiderComment"
      class="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-[#1f273b] peer"
      placeholder=" "
      (keydown)="preventSpaceKey($event)"
      (paste)="onPaste($event, 'insiderComment')"
    />
    <label
      class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto peer-focus:text-[#1f273b] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
    >
      Insider Comment
    </label>
  </div>
  </div>
</div>

<div class="button-group flex justify-end py-3 space-x-2">
  <button
    class="bg-[#1f273b] text-white hover:bg-[#1f273b] text-6ray-800 py-1 px-3 cursor-pointer border border-[#d9d9d9] rounded"
    (click)="onSubmit()"
  >
    Submit
  </button>
  <button
    class="bg-white hover:bg-gray-100 text-6ray-800 py-1 px-3 cursor-pointer border border-[#d9d9d9] rounded"
    (click)="onCancel()"
  >
    Cancel
  </button>
</div>
